import { RouteLocationNormalized } from 'vue-router';
import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { IAppRegistration } from '@studyportals/search-page-interface';

export class SearchPageNavigationPerformedEvent implements IEvent {
	public static readonly EventType = 'SearchPageNavigationPerformedEvent';

	public readonly timestamp = new Date();
	public readonly eventType = SearchPageNavigationPerformedEvent.EventType;
	public readonly targetRoute: RouteLocationNormalized;
	public readonly targetApp: IAppRegistration | null;

	public constructor(targetRoute: RouteLocationNormalized, targetApp: IAppRegistration | null) {
		this.targetRoute = targetRoute;
		this.targetApp = targetApp;
	}

	public static is(event: IEvent): event is SearchPageNavigationPerformedEvent {
		return event.eventType === SearchPageNavigationPerformedEvent.EventType;
	}
}
